import { useLocalStorageSet } from '@shared/hooks';

const alertedChangelogEntriesKey = 'alerted-changelog-entries';

export const useAlertedChangelogEntries = () => useLocalStorageSet(alertedChangelogEntriesKey);
